import { A } from '@main/pc-core-components';
import type { AssetFile } from '@main/pc-types';
import { Card } from '@main/privacy-center/src/components/Card';
import { LogoImageWrapper } from '@main/privacy-center/src/containers/Header/wrappers';
import { heroPageMessages } from '@main/privacy-center/src/routes/HeroPage/messages';
import React from 'react';
import { useIntl } from 'react-intl';

export const ChildOrganizationHeader: React.FC<{
  /** Logo for organization */
  logo?: AssetFile;
  /** Name of organization */
  name: string;
  /** URL to link to */
  url?: string;
}> = ({ url, logo, name }) => {
  const { formatMessage } = useIntl();
  const content = logo ? (
    <LogoImageWrapper
      style={{ height: '90px', marginRight: '10px' }}
      src={logo.src}
      alt={formatMessage(logo.alt || heroPageMessages.organizationLogoAlt, {
        organizationName: name,
      })}
    />
  ) : null;
  return (
    <Card>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {url && content ? <A href={url}>{content}</A> : content}
        <h2>
          <b>{name}</b>
        </h2>
      </div>
    </Card>
  );
};
